import _ from "lodash";
import { action, reaction, computed, extendObservable } from "mobx";
import moment from "moment";
import FormStore from "./formStore";

const POLLING_INTERVAL_MS = 10000;

class TrackmanAccuracyReportStore extends FormStore {
  constructor(setiApi, routerStore, limboStore) {
    super(routerStore);

    this.setiApi = setiApi;
    this.routerStore = routerStore;
    this.limboStore = limboStore;

    this.defaults = {
      date: moment().format("YYYY-MM-DD")
    };

    extendObservable(this, {
      isLoading: computed(() => _.isEmpty(this.data) && this.isFetching),
      isFetching: true,
      updatedAt: "",
      data: {},
      formValues: {
        date: this.defaults["date"]
      },
      fetchData: action(() => {
        this.isFetching = true;
        setiApi.fetchTrackmanAccuracyReport(this.get("date")).then(data => {
          this.data = data;
          this.isFetching = false;
          this.updatedAt = moment().format("LTS");
        });
      }),
      startPolling: () => {
        this.poller = setInterval(() => {
          // Only fetch data if we are looking at today's games.
          if (this.get("date") === moment().format("YYYY-MM-DD")) {
            this.fetchData();
          }
        }, POLLING_INTERVAL_MS);
      },
      stopPolling: () => {
        clearInterval(this.poller);
      },
      updateDate: action(date => {
        this.update("date")(date);
        setiApi.cancelTrackmanAccuracyReport();
        this.data = {};
      })
    });

    reaction(
      () =>
        this.routerStore.isTrackmanAccuracyReportTab &&
        this.routerStore.location,
      () => {
        if (this.routerStore.isTrackmanAccuracyReportTab) {
          this.updateFromUrlParams(this.routerStore.location.search);
          this.fetchData();
        }
      },
      true
    );
  }

  transitionToCreateIncident = game => {
    this.limboStore.updateNewIncidentMetadata(game, this.get("date"));
    this.routerStore.history.push("/incidents/new");
  };

  transitionToCreateSystemWideIncident = () => {
    this.limboStore.updateNewSystemIncidentMetadata(this.get("date"));
    this.routerStore.history.push("/incidents/new");
  };
}

export default TrackmanAccuracyReportStore;



// WEBPACK FOOTER //
// ./src/stores/trackmanAccuracyReportStore.js